exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.signStyle[data-v-6ff69cea] {\n  position: absolute;\n  height: 22px;\n  width: 22px;\n  border-radius: 50%;\n  background-color: red;\n  color: #fff;\n  font-size: 12px;\n  line-height: 21px;\n  text-align: center;\n  top: 0px;\n  left: 20px;\n}\n", ""]);

// exports
